import Vue from 'vue'
import Vuex from 'vuex'

import candidate from './candidate'
import client from './client'
import auth from './auth'
import campaign from './campaign'

import behavioralCompetencies from './behavioral_competencies'
import disciplines from './disciplines'
import geolocation from './geolocation'
import institutions from './institutions'
import opportunities from './opportunities'
import organizations from './organizations'
import qualifications from './qualifications'
import qualificationCategories from './qualification_categories'
import qualificationComponents from './qualification_components'
import qualificationTypes from './qualification_types'
import requirements from './requirements'
import images from './images'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    // Role modules
    candidate,
    client,
    // Auth module
    auth,
    campaign,
    // Public endpoints
    behavioralCompetencies,
    disciplines,
    geolocation,
    institutions,
    opportunities,
    organizations,
    qualifications,
    qualificationCategories,
    qualificationComponents,
    qualificationTypes,
    requirements,
    images,
  },
  state: {
    drawer: false,
    snackbar: null,
    update: {
      available: false,
      snoozed: false,
      worker: null,
    },
  },
  getters: {
    snackbar: state => state.snackbar,
  },
  mutations: {
    toggleDrawer: state => (state.drawer = !state.drawer),
    closeDrawer: state => (state.drawer = false),
    snackbar: (state, details) =>
      (state.snackbar = details ? Object.assign({ timeout: 6000, type: 'info' }, details) : null),
    updateWorker: (state, worker) => {
      state.update.available = true
      state.update.worker = worker
      state.update.snoozed = false
    },
  },
  actions: {
    snackbar({ commit }, { type, text, dark, button }) {
      commit('snackbar', { type, text, dark, button })
    },
    snackbarShow({ commit }, message) {
      commit('snackbar', { text: message })
    },
    snackbarSuccess({ commit }, message) {
      commit('snackbar', {
        text: message,
        type: 'success',
      })
    },
    snackbarError({ commit }, message) {
      commit('snackbar', {
        text: message,
        type: 'error',
      })
    },
    cacherefresh({ state }) {
      if (state.update.worker) state.update.worker.postMessage({ type: 'SKIP_WAITING' })
    },
  },
})

export default store
